import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

const t = getTranslation('user.EditLocationsForm');

export interface IAddOfficeFormSchema {
  name: string;
  idexxAccountNumber?: string;
  zoetisAccountNumber?: string;
  regionId: string;
}

export const addOfficeFormSchema: yup.SchemaOf<IAddOfficeFormSchema> =
  yup.object({
    name: yup
      .string()
      .max(100, t('lessThan', { max: 100 }))
      .strict(true)
      .trim(t('mustBeTrimmed'))
      .required(t('locationNameIsRequired')),
    zoetisAccountNumber: yup
      .string()
      .max(100, t('lessThan', { max: 100 }))
      .optional()
      .trim(t('mustBeTrimmed')),
    idexxAccountNumber: yup
      .string()
      .max(100, t('lessThan', { max: 100 }))
      .optional()
      .trim(t('mustBeTrimmed')),
    regionId: yup.string().required(t('regionIsRequired')),
  });
